<template>
  <div class="relative">
    <mia-multi-select
      v-bind="attrs"
      v-on="listeners"
    >
      <template #singleLabel="{ option }">
        <template v-if="findCarById(option)">
          <span
            v-if="!isEmpty(findCarById(option).fin)"
            v-text="findCarById(option).fin"
          />
          <span v-else>FIN UNBEKANNT</span>

          <span
            v-if="!isEmpty(findCarById(option).commission_number)"
            class="ml-1"
            v-text="`(${findCarById(option).commission_number})`"
          />
        </template>
      </template>

      <template #option="{ option }">
        <div
          v-if="option.$isLabel"
          class="text-gray-700"
        >
          <span v-if="isEmpty(option.$groupLabel)">
            Ohne Modellangabe
          </span>
          <span
            v-else
            v-text="option.$groupLabel"
          />
        </div>
        <div v-else>
          <span
            v-if="!isEmpty(option.fin)"
            v-text="option.fin"
          />
          <span v-else>FIN UNBEKANNT</span>

          <span
            v-if="!isEmpty(option.commission_number)"
            class="ml-1"
            v-text="`(${option.commission_number})`"
          />
        </div>
      </template>
    </mia-multi-select>

    <transition
      enter-class="opacity-0"
      enter-active-class="transition-opacity duration-100 ease-out"
      enter-to-class="opacity-100"
      leave-class="opacity-100"
      leave-active-class="transition-opacity duration-100 ease-out"
      leave-to-class="opacity-0"
    >
      <div
        v-if="$wait.is('searching for cars')"
        class="absolute inset-y-0 right-0 flex items-center justify-center w-8 m-px mr-1 bg-white"
        style="z-index: 51;"
      >
        <mia-spinner
          class="w-5 h-5 text-orange-mia"
        />
      </div>
    </transition>
  </div>
</template>

<script>
import debounce from 'lodash/debounce'
import flatten from 'lodash/flatten'
import map from 'lodash/map'
import { getExchangeOptions } from '@/api/cars'
import Spinner from '@/components/ui/loader/Spinner.vue'
import ChecksForEmptyValues from '@/mixins/ChecksForEmptyValues'

export default {
  name: 'MiaCarExchangeSelect',

  components: {
    'mia-spinner': Spinner
  },

  mixins: [ChecksForEmptyValues],

  props: {
    value: {
      type: [String, Number],
      default: ''
    },

    id: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      options: []
    }
  },

  computed: {
    attrs() {
      return {
        placeholder: 'Fahrzeuge durchsuchen...',
        ...this.$attrs,
        id: this.id,
        'internal-search': false,
        label: 'model_title',
        'group-label': 'group',
        'group-select': false,
        'group-values': 'options',
        options: this.options,
        'track-by': 'id',
        value: this.value
      }
    },

    listeners() {
      return {
        ...this.$listeners,
        'search-change': this.onSearchChange,
        input: this.onInput
      }
    }
  },

  watch: {
    value: {
      immediate: true,
      async handler(value) {
        this.$wait.start('searching for cars')
        this.options = this.group(await getExchangeOptions({ include: value || undefined }))
        this.$wait.end('searching for cars')
      }
    }
  },

  methods: {
    group(options) {
      const groupedOptions = []

      Object.entries(options).forEach(([group, groupOptions]) => {
        groupedOptions.push({
          group,
          options: groupOptions
        })
      })

      return groupedOptions
    },

    findCarById(carId) {
      const flattenedOptions = flatten(map(this.options, 'options'))

      return flattenedOptions.find(option => parseInt(option.id, 10) === parseInt(carId, 10))
    },

    // eslint-disable-next-line prefer-arrow-callback
    searchCars: debounce(async function (query) {
      this.options = this.group(await getExchangeOptions({ include: this.value || undefined, query }))
      this.$wait.end('searching for cars')
    }, 1000),

    onSearchChange(query) {
      this.$wait.start('searching for cars')
      this.searchCars(query)
    },

    onInput(option) {
      this.$emit('input', option.id)
    }
  }
}
</script>
